import { render, staticRenderFns } from "./signup.component.vue?vue&type=template&id=4f97ff7e"
import script from "./signup.component.ts?vue&type=script&lang=ts&external"
export * from "./signup.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f97ff7e')) {
      api.createRecord('4f97ff7e', component.options)
    } else {
      api.reload('4f97ff7e', component.options)
    }
    module.hot.accept("./signup.component.vue?vue&type=template&id=4f97ff7e", function () {
      api.rerender('4f97ff7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/signup/signup.component.vue"
export default component.exports